<div class="fdk-loading-dots">
  <span class="fdk-loading-dots__dot"></span>
  <span class="fdk-loading-dots__dot"></span>
  <span class="fdk-loading-dots__dot"></span>
</div>
